import { useTranslation } from "react-i18next";
import { Calendar, Check, Clock, Play } from "lucide-react";

import BaseBadge from "@/components_v2/Badge/BaseBadge";
import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

import { EventCardProps } from "../types";

const EventCard = ({
  date,
  time,
  title,
  description,
  isCompleted,
  linkUrl,
}: EventCardProps) => {
  const { t } = useTranslation();
  const hasLink = linkUrl != null && linkUrl !== "";

  return (
    <div className="guidance-page-event-card flex flex-col gap-250">
      <div className="guidance-page-event-card-header flex items-start justify-between gap-200">
        <h3 className="guidance-page-event-card-title header-s-medium">
          {title}
        </h3>

        {isCompleted && (
          <BaseBadge
            className="shrink-0"
            children={t("labels.complete")}
            backgroundColor="var(--green-700-10)"
            fontColor="var(--green-700)"
            leadingIcon={<Check size={16} />}
          />
        )}
      </div>

      <div className="guidance-page-event-card-datetime flex flex-wrap items-center gap-x-300 gap-y-100">
        <span className="flex items-center gap-100">
          <Calendar
            className="guidance-page-event-card-datetime-icon"
            size={16}
            aria-hidden
          />
          <span className="guidance-page-event-card-date body-m-regular">
            {date}
          </span>
        </span>

        <span className="flex items-center gap-100">
          <Clock
            className="guidance-page-event-card-datetime-icon"
            size={16}
            aria-hidden
          />
          <span className="guidance-page-event-card-time body-m-regular">
            {time}
          </span>
        </span>
      </div>

      <p className="guidance-page-section-description body-m-regular">
        {description}
      </p>

      {hasLink && (
        <BaseButton
          variant={
            isCompleted ? BUTTON_VARIANTS.TERTIARY : BUTTON_VARIANTS.PRIMARY
          }
          size={BUTTON_SIZES.SMALL}
          leadingIcon={isCompleted ? <Play size={16} /> : undefined}
          onClick={() => window.open(linkUrl, "_blank", "noopener,noreferrer")}
        >
          {isCompleted ? t("labels.viewRecording") : t("labels.registerNow")}
        </BaseButton>
      )}
    </div>
  );
};

export default EventCard;
